import './UserLanguageMenu.scss'
import React, {useContext, useEffect, useState} from "react";
import {I18nReactContext} from "../../contexts/I18nContext";
import {languagesMap} from "../../contexts/ContextLib";
import {Language} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import {map} from "lodash";
import {CompanyReactContext} from "../../contexts/CompanyContext";
import {FeatureFlags} from "../../Utils/Constants";


export const UserLanguageMenu = ({size}) => {
    const {i18n, switchLanguage, language} = useContext(I18nReactContext);
    const companyContext = useContext(CompanyReactContext);
    const [languagesOptions, setLanguagesOptions] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const iconSize = size === 'small' ? 16 : 32;

    useEffect(() => {
        setLanguagesOptions(Object.keys(languagesMap).map(language => {
                return {
                    text: i18n.translate(`languages.languageKeys.${language}`),
                    value: language,
                }
            }
        ))
    }, []);


    const onSelectedLanguage = ({language}) => {
        switchLanguage({newSelectedLanguage: language})
    }

    return (
        <div className="UserIconMenu">
            <div className="languageIconButtonWrapper" onClick={handleClick}>
                <IconButton

                    size="small"
                    aria-controls={open ? 'language-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                >
                    <Language fontSize="small"/>
                </IconButton>
                {i18n.translate(`languages.languageKeys.${language}`)}
            </div>
            <Menu
                anchorEl={anchorEl}
                id="language-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                        },
                    },
                }}
                transformOrigin={{horizontal: 'right', vertical: 'top'}}
                anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
            >
                {companyContext.featureFlags[FeatureFlags.LANGUAGES] ? [
                    <MenuItem key="title">
                        {i18n.translate('languages.label')}
                    </MenuItem>,
                    <Divider key="divider-1"/>,
                    ...map(languagesOptions, (option) => {
                        return <MenuItem key={option.value}
                                         onClick={() => onSelectedLanguage({language: option.value})}>
                            {/*<ListItemIcon>*/}
                            {/*    <Language fontSize="small"/>*/}
                            {/*</ListItemIcon>*/}
                            {option.text}
                        </MenuItem>
                    }),
                    <Divider key="divider-2"/>
                ] : ''}
            </Menu>
            {/*<Language fontSize="large"/>*/}
            {/*<div className="selectBoxWrapper">*/}
            {/*    <SelectBox options={languagesOptions} value={language}*/}
            {/*               onChange={onSelectedLanguage}/>*/}
            {/*</div>*/}
        </div>
    );
}